import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import axios from "axios";

import edit from "../../images/edit.svg";
import Delete from "../../images/delete.svg";
import Logo from "../../images/logo-2.png";
import { useSelector } from "react-redux";
import api from "../../api";
import { Pagination, Stack } from "@mui/material";
import { Loader } from "./loader";
import moment from "moment";
import copy from "copy-to-clipboard";
import "./UnsubscribedUsers.css";
import { useAlert } from "react-alert";

function UnSubscribedUsers({ match }) {
      const alert = useAlert();
  
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [data, setData] = useState([]);
  const [noOfUser, setnoOfUser] = useState(0);
  const [loader, setLoader] = useState(true);
  const [searchMail, setSearchMail] = useState("");
  const [resetPage, setResetPage] = useState(false);

  const getUsers = async () => {
    try {
      let payload = {
        page: page,
      };
      setLoader(true);
      const userData = await api.getUnSubscribedUsers(payload);
      setData(userData.user);
      setnoOfUser(userData.count);
      setLimit(userData.limit);
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const handleSearch = async () => {
    if (searchMail) {
      let payload = {
        email: searchMail,
      };
      const res = await api.searchUnsubscribedUsers(payload);
      if (res?.success) {
        setData(res?.user);
      } else {
        alert.error("Invalid Email Address");
      }
    } else {
      alert.info("Please insert email for search");
    }
  };

  useEffect(() => {
    getUsers();
  }, [page, resetPage]);

  const handleReset = () => {
    setResetPage(!resetPage);
    setPage(1);
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col">
            <div className="unsub-users-management-wrapper">
              {/* Header Section */}
              <div className="unsub-users-header-section mb-5">
                <div className="unsub-users-header-content">
                  <div className="unsub-users-title-section">
                    <h1 className="unsub-users-main-title">
                      <i className="fas fa-user-slash unsub-users-title-icon me-3"></i>
                      Unsubscribed Users
                    </h1>
                    <p className="unsub-users-subtitle">
                      View and manage users who have canceled their premium
                      subscriptions
                    </p>
                  </div>

                  {/* Stats Card */}
                  <div className="unsub-users-stats-container">
                    <div className="unsub-users-stat-card">
                      <div className="unsub-users-stat-icon">
                        <i className="fas fa-users-slash"></i>
                      </div>
                      <div className="unsub-users-stat-content">
                        <h3 className="unsub-users-stat-number">{noOfUser}</h3>
                        <p className="unsub-users-stat-label">
                          Unsubscribed Users
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Search and Reset Section */}
                <div className="unsub-users-search-section">
                  <div className="unsub-users-search-container">
                    <div className="unsub-users-search-input-wrapper">
                      <i className="fas fa-search unsub-users-search-icon"></i>
                      <input
                        type="text"
                        className="unsub-users-search-input"
                        placeholder="Search unsubscribed users by email address..."
                        value={searchMail}
                        onChange={(e) => setSearchMail(e.target.value)}
                        onKeyPress={(e) => e.key === "Enter" && handleSearch()}
                      />
                      {searchMail && (
                        <button
                          className="unsub-users-search-clear"
                          onClick={() => setSearchMail("")}
                        >
                          <i className="fas fa-times"></i>
                        </button>
                      )}
                    </div>
                    <button
                      className="unsub-users-search-btn"
                      onClick={handleSearch}
                    >
                      <i className="fas fa-magnifying-glass me-2"></i>
                      Search
                    </button>
                  </div>
                  <button
                    className="unsub-users-reset-btn"
                    onClick={handleReset}
                  >
                    <i className="fas fa-arrows-rotate me-2"></i>
                    Reset
                  </button>
                </div>
              </div>

              {/* Table Section - KEEPING EXACT STRUCTURE */}
              <div className="card sortby-box br-10 border-transparent mt-3 unsub-users-table-card">
                <div className="card-header br-10 bg-white border-transparent py-3">
                  <Table
                    data={data}
                    setPage={setPage}
                    page={page}
                    noOfUser={noOfUser}
                    limit={limit}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {loader && <Loader />}

      {/* Styles */}
      <style jsx>{``}</style>
    </>
  );
}

const Table = ({ data, page, setPage, noOfUser, limit }) => {
  // const authedUser = useSelector(s => s.authedUser.authedUser);
  const [copyText, setCopyText] = useState("Copy to clipboard");

  const handleChange = (event, value) => {
    setPage(value);
  };

  const formatDate = (date) => {
    let dateTemp = moment(date).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };

  const handleCopy = (text) => {
    copy(text);
    setCopyText("Copied");
    setTimeout(() => {
      setCopyText("Copy to clipboard");
    }, 3000);
  };

  const checkDate = (nextPayment) => {
    let currentDate = new Date();
    let endDate = new Date(nextPayment);

    if (endDate > currentDate) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <>
      <div className="table-responsive">
        <table className="table table-hover drivers-table">
          <thead>
            <tr>
              <th scope="col" className="">
                Name
              </th>
              <th scope="col" className="">
                Email
              </th>
              <th scope="col" className="">
                Reason
              </th>
              <th scope="col" className="">
                <div className="w-max-c">Last Paid</div>
              </th>
              <th scope="col" className="">
                <div className="w-max-c">Subscription End</div>
              </th>
            </tr>
          </thead>
          <tbody>
            {data.length === 0 ? (
              <tr>
                <td colSpan="5">
                  <div className="empty-state">
                    <div className="empty-state-icon">
                      <i className="fas fa-user-slash"></i>
                    </div>
                    <h3 className="empty-state-title">
                      No Unsubscribed Users Found
                    </h3>
                    <p className="empty-state-description">
                      There are currently no users who have canceled their
                      subscriptions.
                    </p>
                  </div>
                </td>
              </tr>
            ) : (
              data.map((item, key) => (
                <tr key={key}>
                  <td scope="row">
                    <div className="table-text-dark w-max-c db">
                      {item?.userdata?.name || item?.name}
                    </div>
                  </td>
                  <td>
                    <span className="table-text-dark w-max-c db">
                      {item?.userdata?.email || item?.email}
                    </span>
                  </td>
                  <td>
                    <span className="table-text-dark w-max-c db">
                      {item?.unSubscribeReason}
                    </span>
                  </td>
                  <td>
                    <div className="table-text-dark w-max-c db">
                      {item?.lastPaid ? formatDate(item?.lastPaid) : "-"}
                    </div>
                  </td>
                  <td>
                    <div
                      className={
                        checkDate(item?.nextPayment)
                          ? "color-green table-text-dark w-max-c db"
                          : "color-red table-text-dark w-max-c db"
                      }
                    >
                      {item?.lastPaid ? formatDate(item?.nextPayment) : "-"}
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      {data.length > 0 && (
        <div className="d-flex justify-content-center mt-4">
          <Stack spacing={2}>
            <Pagination
              count={Math.ceil(noOfUser / limit)}
              page={page}
              onChange={handleChange}
              color="primary"
              sx={{
                "& .MuiPaginationItem-root.Mui-selected": {
                  backgroundColor: "#ef4444",
                  color: "white",
                  "&:hover": {
                    backgroundColor: "#dc2626",
                  },
                },
                "& .MuiPaginationItem-root": {
                  "&:hover": {
                    backgroundColor: "#fee2e2",
                    color: "#dc2626",
                  },
                },
              }}
            />
          </Stack>
        </div>
      )}
    </>
  );
};

export default UnSubscribedUsers;
